import { Link } from "react-router-dom";

import type { Tool } from "../tools.data";

import styles from "./ToolCard.module.css";

interface ToolCardProps {
  tool: Tool;
}

/**
 * A single tool tile: icon, name, description, and client tag.
 * When the tool has a page (`path`), the whole card links to it; otherwise it
 * renders as a static tile. A feature-local component.
 */
export function ToolCard({ tool }: ToolCardProps) {
  const { icon: Icon, name, description, client, status, path } = tool;

  const inner = (
    <>
      <header className={styles.head}>
        <span className={styles.icon}>
          <Icon />
        </span>
      </header>
      <h3 className={styles.title}>{name}</h3>
      <p className={styles.description}>{description}</p>
      <footer className={styles.foot}>
        <span className={styles.client}>{client}</span>
      </footer>
    </>
  );

  if (path) {
    return (
      <Link to={path} className={`${styles.card} ${styles.linkCard} ${styles[status]}`}>
        {inner}
      </Link>
    );
  }

  return <article className={`${styles.card} ${styles[status]}`}>{inner}</article>;
}
